import React from "react";
import { Navigate } from "react-router-dom";

export const PrivateRoute = ({ children }) => {
  const token = localStorage.token;
  return token ? children : <Navigate to="/Login" />;
};
